(() => {
    const hpShortcuts = document.querySelector(".hp-shortcuts");

  
    // callback is called on intersection change
    const onIntersection = (entries, opts) => {
      entries.forEach((entry) =>
        entry.target.classList.toggle("visible", entry.isIntersecting)
      );
    };
  
    const seeScroll = () => {
      let observer = new IntersectionObserver(onIntersection, {
        root: null, // default is the viewport
        threshold: 0.1, // percentage of target's visible area. Triggers "onIntersection"
      });
  
      observer.observe( hpShortcuts );
      // observer.unobserve(entry.target);
    };
  
    const init = () => {
      if (hpShortcuts) {
        seeScroll();
      }
    };
  
    init();
  })();
  